import { render, staticRenderFns } from "./proxyPositionList.vue?vue&type=template&id=5708e371&scoped=true"
import script from "./proxyPositionList.vue?vue&type=script&lang=js"
export * from "./proxyPositionList.vue?vue&type=script&lang=js"
import style0 from "./proxyPositionList.vue?vue&type=style&index=0&id=5708e371&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5708e371",
  null
  
)

export default component.exports